import { useGameStore } from '../stores/game.js';
import styles from './EpochBadge.module.css';

const EPOCH_NAMES = [
  'искра',
  'фрактальный метод',
  'ФРАКТАЛiТи',
  'МОГА',
  'Sai Land Heal',
  'МОГАзинус',
  'МОГАsound',
  'ретриты',
  'сеть Рощ',
  'светогромовое шоу',
  'новый мир',
  'создатель',
] as const;

const ROMAN = ['I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX', 'X', 'XI', 'XII'] as const;

export function EpochBadge(): JSX.Element {
  const epoch = useGameStore((s) => s.state.epoch);
  const name = EPOCH_NAMES[epoch - 1] ?? '';
  const numeral = ROMAN[epoch - 1] ?? '';
  return (
    <div className={styles.root}>
      <span className={styles.label}>эпоха</span> <span className={styles.numeral}>{numeral}</span>
      <span className={styles.dot} aria-hidden>
        ·
      </span>
      <span className={styles.name}>{name}</span>
    </div>
  );
}
